/**
 * 判断当前是否为本地开发路径（需加 /--roboneo 前缀）
 */
function isRoboneoDevPath(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.location.pathname.startsWith('/--roboneo')
    || process.env.NEXT_PUBLIC_ENV === 'development';
}

/**
 * 获取 Roboneo 站内页面完整 URL，域名跟随当前访问环境
 *
 * @param pathname 页面路径，如 /membership-agreement
 * @param query 查询参数
 */
export function getRoboneoPageUrl(
  pathname: string,
  query?: Record<string, string | number | undefined>,
): string {
  if (typeof window === 'undefined') {
    return pathname;
  }
  const pathPrefix = isRoboneoDevPath() ? '/--roboneo' : '';
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const url = new URL(`${pathPrefix}${normalizedPath}`, window.location.origin);
  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        url.searchParams.set(key, String(value));
      }
    });
  }
  return url.toString();
}
